import {
  axios_institute_private,
  axios_openSearch,
} from "../../../../../api/setup.intersepter";
import { InstitutionsDTO } from "./types";

export const InstitutionsRequest = (body: InstitutionsDTO) => {
  return axios_institute_private({
    method: "PUT",
    url: `/institutions`,
    data: body,
  });
};
export const GetInstituteByIdRequest = (Id: string) => {
  return axios_institute_private({
    method: "GET",
    url: `/institutions?instituteId=${Id}`,
  });
};

export const GetGlobalSearch = (body: any) => {
  return axios_openSearch({
    method: "POST",
    url: `/elastic_search/nurtureSearch`,
    data: body,
  });
};

export const GetContactById = (Id: string) => {
  return axios_institute_private({
    method: "GET",
    url: `/studentContact?studentContactId=${Id}`,
  });
};

export const ContactToLead = (body: any) => {
  return axios_institute_private({
    method: "POST",
    url: `/studentContact?action=contactToEnquiry`,
    data: body,
  });
};
